// extracted by mini-css-extract-plugin
export default {"root":"ButtonAddPlus_root__ir4qa","icon":"ButtonAddPlus_icon__Zu0iz","hint":"ButtonAddPlus_hint__10X3F","tooltipBelow":"ButtonAddPlus_tooltipBelow__9pUiz"};